/**
 * `status_id` groups on `get-cl-hair` — the same filters as CRM > Profile > Hair in EVO.
 * `OnOrder` is a subset of `Pending`: systems ordered from the vendor but not yet received.
 */
export enum HairStatusGroup {
  Available = 1,
  Delivered = 2,
  Pending = 3,
  Inactive = 4,
  OnOrder = 5
}

/** `sort_by` on `get-cl-hair`, ordered by the system's created date. */
export enum HairSortOrder {
  OldestFirst = 0,
  NewestFirst = 1
}

export interface GetClHairParams {
  status_id: HairStatusGroup;
  /** Hair type filter; 0 = all. */
  hr_type_id?: number;
  sort_by?: HairSortOrder;
  /** Max records to return (API default 100). */
  first?: number;
  skip?: number;
}

/**
 * One row of `get-cl-hair`. Everything past the identifiers is nullable in practice: a
 * system on order has no received date, and most systems carry no linked appointment.
 */
export interface HairSystem {
  o_hair_num: number;
  o_date: string | null;
  o_time?: string | null;
  o_hr_type_num?: number | null;
  o_hr_type_name?: string | null;
  o_hr_type_categorynum?: number | null;
  o_hr_type_category?: string | null;
  o_status_num?: number | null;
  o_status_name?: string | null;
  o_vendornum?: number | null;
  o_vendor_name?: string | null;
  o_in_itemnum?: number | null;
  o_invoice_link_num?: number | null;
  o_hair_imprint?: string | null;
  o_store_num?: number | null;
  o_hair_dt_order?: string | null;
  o_hair_dt_received?: string | null;
  o_apt_servicenum?: number | null;
  o_appointmentnum?: number | null;
  o_apt_service_start_date?: string | null;
  o_apt_service_start_tm?: string | null;
  o_apt_service_start_ts_utc?: string | null;
  o_apt_empl_num?: number | null;
  o_apt_empl_short?: string | null;
  checkout_id?: number | null;
}

export interface GetHairSystemsArgs {
  status: HairStatusGroup;
  limit: number;
  skip?: number;
}

export interface HairSystemsPage {
  list: HairSystem[];
  /** `get-cl-hair` returns a bare array, so this comes from over-fetching one row. */
  hasMore: boolean;
}
